import moment from "moment";
import SelectCodeMasterCategoryComponent from "../../../../components/code-master/select-code-master-category.component";
import DatePickerComponent from "../../../../components/date-picker/date-picker.component";
import paginationComponent from "../../../../components/pagination/pagination.component";
import SelectSiteUDFCustomerComponent from "../../../../components/site-udf-customer/select-site-udf-customer.component";
import SelectSiteSearchInputComponent from "../../../../components/site/select-site-search-input.component";
import { formats as FORMATS, codeMasterType } from "../../../../config/constants";
import loginModel from "../../../../models/login.model";
import SMSLogFSMModel from "../../../../models/sms-log-fsm/sms-log-fsm.model";
import ViewBase from "../../../view-base.view";

/**
 * SMS Log
 *
 *
 * @author cmc.kmduc1(Henry)
 */

export default function SMSLogFSMSavina() {
  ViewBase.call(this);

  const DEFAULT_FILTERS = Object.freeze({
    fromDate: moment().format(FORMATS.ISO_DATE_FORMAT),
    toDate: moment().format(FORMATS.ISO_DATE_FORMAT),
    fsmId: '',
    accept: '',
    sites: [],
    customers: [],
    type: '',
    imeiOrSerialNo: '',
    toMatchFlag: '',
  });

  const DEFAULT_PAGINATION = Object.freeze({
    pageIndex: 1,
    pageSize: 10,
    totalCount: 0
  });

  let filters = structuredClone(DEFAULT_FILTERS);
  let pagination = structuredClone(DEFAULT_PAGINATION);
  let currentFilters = structuredClone(DEFAULT_FILTERS);

  let tableData = [];

  const getSMSLogFSM = () => {
    this.showLoading();

    const body = {
      dateFrom: moment(currentFilters.fromDate).format('YYYYMMDD'),
      dateTo: moment(currentFilters.toDate).format('YYYYMMDD'),
      fsmId: currentFilters.fsmId,
      accept: currentFilters.accept,
      siteIds: currentFilters.sites.map(site => site.siteId),
      customerCodes: currentFilters.customers.map(site => site.customerCode),
      type: currentFilters.type,
      imeiOrSerialNo: currentFilters.imeiOrSerialNo,
      toMatchFlag: currentFilters.toMatchFlag,
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
    }

    SMSLogFSMModel.getSMSLogFSM(body)
      .then(result => {
        tableData = result.data
        pagination.pageIndex = result.pageIndex
        pagination.pageSize = result.pageSize
        pagination.totalItems = result.total
      })
      .catch(error => {
        this.handleError(error)
      })
      .finally(() => {
        this.hideLoading()
      });
  }

  const handleSearchClick = () => {
    currentFilters = structuredClone(filters)
    pagination.pageIndex = 1

    getSMSLogFSM()
  }

  const handleClear = () => {
    filters = structuredClone(DEFAULT_FILTERS);
  }

  const handlePageIndexChange = (pageIndex) => {
    pagination.pageIndex = pageIndex
    getSMSLogFSM()
  }

  const handlePageSizeChange = (pageIndex, pageSize) => {
    pagination.pageSize = pageSize
    pagination.pageIndex = pageIndex
    getSMSLogFSM()
  }

  const handleSMSPeriodChange = (e) => {
    filters.fromDate = moment(e.detail.start).format(FORMATS.ISO_DATE_FORMAT);
    filters.toDate = moment(e.detail.end).format(FORMATS.ISO_DATE_FORMAT);
  }

  const handleSiteChange = (sites) => {
    filters.sites = sites;
  }

  const handleFSMIdChange = (e) => {
    filters.fsmId = e.target.value;
  }

  const handleIMEIOrSerialNoChange = (e) => {
    filters.imeiOrSerialNo = e.target.value;
  }

  const handleExcelDownloadClick = () => {
    this.showLoading();

    const body = {
      dateFrom: moment(currentFilters.fromDate).format('YYYYMMDD'),
      dateTo: moment(currentFilters.toDate).format('YYYYMMDD'),
      inputUserLanguageCode: loginModel.credentials.country,
      customerCodes: currentFilters.customers.map(site => site.customerCode).join('^'),
      siteIds: currentFilters.sites.map(site => site.siteId).join('^'),
      fsmId: currentFilters.fsmId,
      accept: currentFilters.accept,
      imeiOrSerialNo: currentFilters.imeiOrSerialNo,
      type: currentFilters.type,
      toMatchFlag: currentFilters.toMatchFlag,
    }

    SMSLogFSMModel.excelDownload(body, `export-savina-sms-log-fsm-${moment().format('YYYYMMDD-HHmmss')}`)
      .catch(error => {
        this.handleError(error)
      })
      .finally(() => {
        this.hideLoading()
      });
  }

  return {
    oninit: () => {
      getSMSLogFSM();
    },
    view: () => {
      return [
        /* SEARCH */
        m('.card.mb-3',
          m(".card-body",
            m(".row.g-2",
              m(".col-xl-3.col-lg-4.col-sm-6",
                m("label.form-label[for=smsPeriod]",
                  this.getText("LT00001106", "SMS Period")
                ),
                m(DatePickerComponent, {
                  id: 'smsPeriod',
                  class: 'form-control',
                  readonly: true,
                  isRange: true,
                  hasLock: true,
                  minDays: 1,
                  maxDays: 30,
                  dateStart: filters?.fromDate,
                  dateEnd: filters?.toDate,
                  onselect: handleSMSPeriodChange
                })
              ),
              m(".col-xl-3.col-lg-4.col-sm-6",
                m('label.form-label[for="fsmId"]', this.getText("LT00001107", "FSM ID")),
                m('input.form-control.form-control-bg',
                  {
                    maxLength: 30,
                    id: 'fsmId',
                    onchange: handleFSMIdChange,
                    placeholder: this.getText("LT00001107", "FSM ID"),
                    value: filters.fsmId
                  })
              ),
              m('.col-xl-3.col-lg-4.col-sm-6',
                m('label.form-label[for=accept]', this.getText('LT00001108', 'Accept')),
                m(SelectCodeMasterCategoryComponent, {
                  id: 'accept',
                  category: codeMasterType.smsLogFSMAccept,
                  isMultiple: false,
                  keyOnly: true,
                  selectedItem: filters.accept,
                  onSelect: (value) => {
                    filters.accept = value;
                  }
                })
              ),
              m(".col-xl-3.col-lg-4.col-sm-6",
                m('label.form-label[for="sites"]', this.getText("LT00000516", "Site(s)")),
                m(SelectSiteSearchInputComponent, {
                  id: 'sites',
                  multiple: true,
                  selectedItems: filters.sites,
                  onSelect: handleSiteChange,
                })
              ),
              m('.col-xl-3.col-lg-4.col-sm-6',
                m('label.form-label[for=customers]', this.getText('LT00001109', 'Customer(s)')),
                m(SelectSiteUDFCustomerComponent, {
                  id: 'customers',
                  isMultiple: true,
                  selectedItems: filters.customers,
                  onSelect: (value) => {
                    filters.customers = value;
                  }
                })
              ),
              m('.col-xl-3.col-lg-4.col-sm-6',
                m('label.form-label[for=type]', this.getText('LT00000117', 'Type')),
                m(SelectCodeMasterCategoryComponent, {
                  id: 'type',
                  category: codeMasterType.smsLogFSMSNType,
                  isMultiple: false,
                  keyOnly: true,
                  selectedItem: filters.type,
                  onSelect: (value) => {
                    filters.type = value;
                  }
                })
              ),
              m(".col-xl-3.col-lg-4.col-sm-6",
                m('label.form-label[for="imei"]', this.getText("LT00001087", "IMEI / Serial No.")),
                m('input.form-control.form-control-bg',
                  {
                    id: 'imei',
                    maxLength: 30,
                    onchange: handleIMEIOrSerialNoChange,
                    placeholder: this.getText("LT00001087", "IMEI / Serial No."),
                    value: filters.imeiOrSerialNo
                  })
              ),
              m('.col-xl-3.col-lg-4.col-sm-6',
                m('label.form-label[for=toMatchFlag]', this.getText('LT00001110', 'To-Match Flag')),
                m(SelectCodeMasterCategoryComponent, {
                  id: 'toMatchFlag',
                  category: codeMasterType.smsLogFSMToMatch,
                  isMultiple: false,
                  keyOnly: true,
                  selectedItem: filters.toMatchFlag,
                  onSelect: (value) => {
                    filters.toMatchFlag = value;
                  }
                })
              ),
              m(".col-12.d-flex.justify-content-end.gap-2",
                m("button.btn.btn-primary",
                  {
                    type: "submit",
                    onclick: handleSearchClick
                  },
                  this.getText("LT00000001", "Search")
                ),
                m("button.btn.btn-white",
                  {
                    type: "button",
                    onclick: handleClear
                  },
                  this.getText("LT00000031", "Clear")
                )
              )
            )
          )
        ),

        /* TABLE */
        m(".card",
          m(".card-body",
            m(".row.g-2",
              m(".col-12.d-flex.justify-content-end",
                m('button.btn.btn-primary.cursor-pointer',
                  {
                    type: 'button',
                    onclick: handleExcelDownloadClick,
                    disabled: tableData.length == 0
                  },
                  m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                )
              ),
              m(".col-12",
                m(".table-responsive",
                  m("table.table.table-hover",
                    m("thead",
                      m("tr.align-middle.text-center",
                        m('th[scope="col"]',
                          this.getText("LT00000721", "No.")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001107", "FSM ID")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001111", "FSM")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001087", "IMEI / Serial No.")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001112", "SMS Date")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001108", "Accept")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00000723", "Site Code")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00000071", "Site")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001090", "Sale Date")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00000717", "Model")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001026", "Customer Code")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00008046", "Customer")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001113", "Points")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00000152", "Remarks")
                        )
                      )
                    ),
                    m("tbody",
                      tableData.length == 0 &&
                      m("tr.align-middle",
                        m("td[colSpan=14]",
                          this.getText("EM00000141", "No records found.")
                        )
                      ),
                      tableData.length > 0 &&
                      tableData.map((data) =>
                        m("tr.align-middle",
                          m("td", m("span.cursor-text", data.no)),
                          m("td", m("span.cursor-text", data.fsmId)),
                          m("td", m("span.cursor-text", data.fsmName)),
                          m("td", m("span.cursor-text", data.imeiOrSerialNo)),
                          m("td", m("span.cursor-text", data.smsDate)),
                          m("td", m("span.cursor-text", data.accept)),
                          m("td", m("span.cursor-text", data.siteCode)),
                          m("td", m("span.cursor-text", data.siteName)),
                          m("td", m("span.cursor-text", data.saleDate)),
                          m("td", m("span.cursor-text", data.model)),
                          m("td", m("span.cursor-text", data.customerCode)),
                          m("td", m("span.cursor-text", data.customerName)),
                          m("td", m("span.cursor-text", data.points)),
                          m("td", m("span.cursor-text", data.remarks)),
                        )
                      )
                    )
                  )
                ),
              ),
              tableData.length != 0 &&
              m(".col-12",
                m(paginationComponent, {
                  currentPage: pagination.pageIndex,
                  pageSize: pagination.pageSize,
                  totalItems: pagination.totalItems,
                  onPageChanged: handlePageIndexChange,
                  onPageSizeChanged: handlePageSizeChange
                })
              )
            )
          )
        ),
        this.getBaseViews(),
      ];
    },
  };
}
